import React, { PropTypes } from 'react';

import GrayPanel from '../../components/GrayPanel/GrayPanel';
import ModalAlert from '../../components/ModalAlert/ModalAlert';
import { runService } from '../../actions/eservices';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import EmptyFileDownloader from '../../components/EmptyFileDownloader';

import Select from 'react-select';
import pans from './panStyle.scss';

import v from './validators';

class PrzedlDzierBudGosp extends React.Component {

  state = {
    service_type: null,
    is_part: null,
    building_type: null,
    parcel_number: null,
    building_area: null,
    town: null,
    extension_from: null,
    extension_to: null,
    building_dest: null,
    other_dest: null,

    teryt: null,

    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
  };

  validators = {
    service_type: [v.NotSelected],
    is_part: [v.NotSelected],
    building_type: [v.NotSelected],
    parcel_number: [v.NotNull],
    building_area: [v.NotNull, v.isNumber],
    town: [v.NotNull],
    extension_from: [v.NotNull, v.CheckDate, v.MaxLength(10)],
    extension_to: [v.NotNull, v.CheckDate, v.MaxLength(10)],
    building_dest: [v.NotSelected]
  };

  errorSpanStyle = {
    color: 'red',
    fontSize: '10px',
  };

  inputStyle = { borderRadius: '0' };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    // Pobieram teryt z linku i przypisuje do state
    const url_string = window.location.href;
    const url = new URL(url_string);
    const c = url.searchParams.get('district');

    this.setState({
      teryt: c,
    });
  }

  insertTestData = () => {
    this.setState({
      service_type: 'wydzierżawienie',
      is_part: 'Nie',
      building_type: 'budynku gospodarczego',
      parcel_number: '123/3',
      building_area: '1000',
      town: 'miejscowosc',
      extension_from: '15-09-2019',
      extension_to: '15-09-2025',
      building_dest: 'biuro'
    });
  };

  handleChangeSelect = (e, name) => {
    this.setState({ [name]: e.value }, () => this.validate(name));
    if (name == 'building_dest' && e.value == 'inne') {
      this.validators['other_dest'] = [v.NotNull]
    } else {
      this.validators['other_dest'] = []
    }
  };

  htmlDecode(input) {
    if (typeof window !== 'undefined') {
      const e = document.createElement('div');
      e.innerHTML = input;
      return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    }
  };

  handleChange = (e, name) => {
    this.setState({ [name]: e.target.value, }, () => this.validate(name));
  };

  getSelectErrorStyle = (name_state) => {
    const selectErrorStyle = {
      borderColor:
        Object.keys(this.state.errors).indexOf(name_state) > -1 &&
          this.state.errors[name_state] !== null &&
          this.state.errors[name_state].length > 0
          ? 'red'
          : '#ccc',
    };
    return selectErrorStyle;
  }

  validateField = (field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validate = (field, callback = null) => {
    let newState = null;
    if (field && Object.keys(this.validators).indexOf(field) > -1) {
      const checks = this.validateField(field);
      newState = {
        errors: {
          ...this.state.errors,
          [field]: checks,
        },
      };
    }
    else {
      let errors = { ...this.state.errors };
      for (const field of Object.keys(this.validators)) {
        const checks = this.validateField(field);
        errors = { ...errors, [field]: checks };
      }
      newState = {
        errors: {
          ...errors
        },
      };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  onHide = () => this.setState({ showError: false });

  onJobFinish = (resp) => {
    if (this.props.serviceInfo.user.userType === 'local') {
      window.location.href = `${this.nextStep}${resp.jobId}`;
    } else {
      window.location.href = `${this.nextStep}${resp.jobId}?customerId=${this.props.query.customerId}`;
    }
  };

  onJobFailed = () => this.setState({
    isWorking: false,
    errorText: 'Wystąpił błąd po stronie serwera. Administrator portalu został poinformowany o zaistniałej sytuacji.',
    errorTitle: 'Tymczasowa niedostępność usługi.',
    showError: true,
  });

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Formularz zawiera błędy.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true
      });
      return;
    }

    if (!hasFieldErrors) {
      const data = {
        service_data: {
          service_type: this.state.service_type,
          is_part: this.state.is_part,
          building_type: this.state.building_type,
          parcel_number: this.state.parcel_number,
          building_area: this.state.building_area,
          town: this.state.town,
          extension_from: this.state.extension_from,
          extension_to: this.state.extension_to,
          building_dest: this.state.building_dest,
          other_dest: this.state.other_dest,
          fk_userID: this.props.serviceInfo.user.ID,
          teryt: this.state.teryt
        },
        teryt: this.state.teryt,
        shortName: this.props.serviceInfo.eservice.shortName,
        user: { ...this.props.serviceInfo.user },
      };
      this.props
        .runService(this.props.serviceInfo.eservice.shortName,
          this.props.district,
          data)
        .then(resp => {
          this.onJobFinish(resp);
        });
    }
  };

  startService = () => {
    this.validate(null, this.postValidation);
  };

  render() {
    // layout classes
    const labelCol = 'col-sm-2';
    const inputCol = 'col-sm-7';

    // really simple styles
    const labelStyle = { marginTop: '.5rem' };
    const rowStyle = { marginTop: '15px' };



    const optionsServiceType = [
      {
        label: 'wydzierżawienie',
        value: 'wydzierżawienie',
      },
      {
        label: 'najem',
        value: 'najem',
      },
    ];

    const optionsIsPart = [
      {
        label: 'Tak',
        value: 'Tak',
      },
      {
        label: 'Nie',
        value: 'Nie',
      },
    ];

    const optionsBuildingType = [
      {
        label: 'budynek gospodarczy',
        value: 'budynku gospodarczego',
      },
      {
        label: 'lokal użytkowy',
        value: 'lokalu użytkowego',
      },
    ];

    const optionsBuildingDest = [
      {
        label: 'cele składowo-magazynowe',
        value: 'cele składowo-magazynowe',
      },
      {
        label: 'punkty sprzedaży - tymczasowe kioski',
        value: 'punkty sprzedaży - tymczasowe kioski',
      },
      {
        label: 'działalność sezonową - letnie kawiarenki',
        value: 'działalność sezonową - letnie kawiarenki',
      },
      {
        label: 'działalność handlowo-usługową',
        value: 'działalność handlowo-usługową',
      },
      {
        label: 'cele garażowe, parkingowe',
        value: 'cele garażowe, parkingowe',
      },
      {
        label: 'biuro',
        value: 'biuro',
      },
      {
        label: 'inne',
        value: 'inne',
      },
    ];

    this.serviceData = [
      {
        label: 'Rodzaj czynności', // Nazwa wyświetlana
        state: this.state.service_type, // Jaki state bedzie trzymal dane
        name_state: 'service_type', // Nazwa state'a zeby zmieniac
        placeholder: 'Wybierz z listy...',
        type_input: 1, // 0 - zwykly input, 1 - React Select
        options: optionsServiceType, // Tablica z wyborami,
      },
      {
        label: 'Czy część nieruchomości?', // Nazwa wyświetlana
        state: this.state.is_part, // Jaki state bedzie trzymal dane
        name_state: 'is_part', // Nazwa state'a zeby zmieniac
        placeholder: 'Wybierz z listy...',
        type_input: 1, // 0 - zwykly input, 1 - React Select
        options: optionsIsPart, // Tablica z wyborami,
      },

      {
        label: 'Rodzaj budynku', // Nazwa wyświetlana
        state: this.state.building_type, // Jaki state bedzie trzymal dane
        name_state: 'building_type', // Nazwa state'a zeby zmieniac
        placeholder: 'Wybierz z listy...',
        type_input: 1, // 0 - zwykly input, 1 - React Select
        options: optionsBuildingType, // Tablica z wyborami,
      },
      {
        label: 'Numer działki', // Nazwa wyświetlana
        state: this.state.parcel_number, // Jaki state bedzie trzymal dane
        name_state: 'parcel_number', // Nazwa state'a zeby zmieniac
        placeholder: 'Numer działki...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Powierzchnia budynku [m&lt;sup&gt;2&lt;/sup&gt;]', // Nazwa wyświetlana
        state: this.state.building_area, // Jaki state bedzie trzymal dane
        name_state: 'building_area', // Nazwa state'a zeby zmieniac
        placeholder: 'Powierzchnia budynku...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },

      {
        label: 'Miejscowość, w której znajduje się budynek', // Nazwa wyświetlana
        state: this.state.town, // Jaki state bedzie trzymal dane
        name_state: 'town', // Nazwa state'a zeby zmieniac
        placeholder: 'Miejscowość...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Data rozpoczęcia dzierżawy/najmu (dd-mm-rrrr)', // Nazwa wyświetlana
        state: this.state.extension_from, // Jaki state bedzie trzymal dane
        name_state: 'extension_from', // Nazwa state'a zeby zmieniac
        placeholder: 'Wprowadź datę...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Data zakończenia dzierżawy/najmu (dd-mm-rrrr)', // Nazwa wyświetlana
        state: this.state.extension_to, // Jaki state bedzie trzymal dane
        name_state: 'extension_to', // Nazwa state'a zeby zmieniac
        placeholder: 'Wprowadź datę...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Przeznaczenie budynku', // Nazwa wyświetlana
        state: this.state.building_dest, // Jaki state bedzie trzymal dane
        name_state: 'building_dest', // Nazwa state'a zeby zmieniac
        placeholder: 'Wybierz z listy...',
        type_input: 1, // 0 - zwykly input, 1 - React Select
        options: optionsBuildingDest, // Tablica z wyborami,
      },
    ];

    return (
      <div>
        <br />
        {this.props.serviceInfo.eservice.requiresUserInfo && this.props.serviceInfo.user ? (
          <div>
            <h3 style={{ textAlign: 'center' }}>
              {this.props.serviceInfo.eservice.title}
            </h3>
            <GrayPanel title="Dane">
              {this.serviceData.map((v, i) => (
                <div key={i} className="row mobile-row container" style={rowStyle}>
                  <div className={labelCol}>
                    <label style={labelStyle} dangerouslySetInnerHTML={{ __html: this.htmlDecode(v.label) }} />
                  </div>
                  <div className={inputCol}>
                    {v.type_input == 0 ? (
                      <input
                        className="form-control"
                        style={{
                          width: '100%',
                          borderColor:
                            Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                              this.state.errors[v.name_state] !== null &&
                              this.state.errors[v.name_state].length > 0
                              ? 'red'
                              : '#ccc',
                        }}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChange(e, v.name_state)}
                      />

                    ) : null}
                    {v.type_input == 1 ? (
                      <Select
                        clearable={false}
                        options={v.options}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChangeSelect(e, v.name_state)}
                        style={this.getSelectErrorStyle(v.name_state)}
                      />
                    ) : null}
                    {/* RENDER ERROS IN SPAN */}
                    {Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                      this.state.errors[v.name_state] !== null &&
                      this.state.errors[v.name_state].length > 0
                      ? this.state.errors[v.name_state].map((val, index) => (
                        <span key={index} style={this.errorSpanStyle}>
                          {val}
                        </span>
                      ))
                      : null}
                  </div>
                </div>
              ))}
              {this.state.building_dest === 'inne' ? (
                <div className="row mobile-row container" style={rowStyle}>
                  <div className={labelCol}>
                    <label style={labelStyle}>Wprowadź inne przeznaczenie</label>
                  </div>
                  <div className={inputCol}>
                    <input
                      className="form-control"
                      style={{
                        width: '100%',
                        borderColor:
                          Object.keys(this.state.errors).indexOf('other_dest') > -1 &&
                            this.state.errors['other_dest'] !== null &&
                            this.state.errors['other_dest'].length > 0
                            ? 'red'
                            : '#ccc',
                      }}
                      value={this.state.other_dest}
                      placeholder={'Wprowadź przeznaczenie...'}
                      onChange={e => this.handleChange(e, 'other_dest')}
                    />
                    {/* RENDER ERROS IN SPAN */}
                    {Object.keys(this.state.errors).indexOf('other_dest') > -1 &&
                      this.state.errors['other_dest'] !== null &&
                      this.state.errors['other_dest'].length > 0
                      ? this.state.errors['other_dest'].map((val, index) => (
                        <span key={index} style={this.errorSpanStyle}>
                          {val}
                        </span>
                      ))
                      : null}
                  </div>
                </div>
              ) : null}
              <div className="row mobile-row pull-right">
                <button
                  className="btn btn-primary"
                  style={rowStyle}
                  onClick={() => this.startService()}
                >
                  Złóż wniosek
                </button>
              </div>
              {this.props.serviceInfo.user &&
                this.props.serviceInfo.user.roles &&
                this.props.serviceInfo.user.roles.indexOf('superadmin') > -1 ? (
                  <button onClick={this.insertTestData} className="btn btn-primary">
                    Insert test data
                </button>
                ) : null}
              <EmptyFileDownloader className="btn btn-primary" position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            </GrayPanel>
          </div>
        ) : null}

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
      </div>
    );
  }
}

PrzedlDzierBudGosp.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.object,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(PrzedlDzierBudGosp),
);


// WEBPACK FOOTER //
// src/routes/eservices/PrzedlDzierBudGosp.js